import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";
import { ArticlePriceService } from "../../../service/articleDelivery/ArticlePriceService";
import UpdateArticlePriceRequest from "../../../model/articleDelivery/UpdateArticlePriceRequest";

export interface AffectedPrice {
    articlePriceId: string;
    agencyId: string;
    agencyName: string;
    currentPrice: number;
    newPrice: number;
    isPersonalized: boolean;
    isSelected: boolean;
}

class NewArticleSalePriceStore {

    public salePriceId: string;
    public articleSalePriceId: string | undefined;
    public articleId: string;
    public value: number;
    public deliveryTimeDays: number | undefined;
    public applyInAllSalePrices: boolean = false;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    // Affected child prices
    public currentValue = 0;
    public affectedPrices: AffectedPrice[] = [];

    public changeError?: string;

    public saved = false;

    constructor(commonStore: CommonStore, salePriceId: string, articleSalePriceId: string | undefined, articleId: string, value: number, deliveryTimeDays: number | undefined) {
        this.salePriceId = salePriceId;
        this.articleSalePriceId = articleSalePriceId;
        this.articleId = articleId;
        this.currentValue = value;
        this.value = value;
        this.deliveryTimeDays = deliveryTimeDays;
        this.isModalOpen = false;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.saved = false;
        this.affectedPrices = [];
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async save() {
        const functionToCall = this.articleSalePriceId ?
            SalePriceService.updateArticleSalePrice(this.salePriceId, this.articleId, this.articleSalePriceId, this.value, this.deliveryTimeDays, this.applyInAllSalePrices) :
            SalePriceService.createArticleSalePrice(this.salePriceId, this.articleId, this.value, this.deliveryTimeDays, this.applyInAllSalePrices);
        const response = await functionToCall;
        this.commonStore.processErrors(response);
        return response.success;
    }

    @action
    public async fetchAffectedPrices() {
        this.loading = true;
        const response = await ArticlePriceService.getAllAgenciesPrices(
            this.salePriceId,
            this.articleId,
            this.deliveryTimeDays
        );
        
        this.commonStore.processErrors(response);
        this.loading = false;
        if (response.success && response.data) {
            this.affectedPrices = response.data.map((price: any) => ({
                articlePriceId: price.id,
                agencyId: price.agencyId,
                agencyName: price.agencyName,
                currentPrice: price.price,
                newPrice: price.price + (this.value - this.currentValue),
                isPersonalized: price.isPersonalized || false,
                isSelected: true,
            }));
        }
    }

    @action
    public async saveChildAgenciesPrice(prices: UpdateArticlePriceRequest[]) {
        this.loading = true;
        const response = await ArticlePriceService.updateBulk(prices);
        this.commonStore.processErrors(response);
        this.loading = false;
        return response.success;
    }

}

export default NewArticleSalePriceStore;